import React from 'react';
import {Button, ModalFooter} from 'react-bootstrap';
import {
    commentsFilter,
    getFilteredComments,
    getSelectedComments,
    OrderedComments,
    markedComments
} from '../../selectors';
import FeaturesState from '../../domain/FeaturesState';
import {
    onDeleteComments,
    setCommentsFilter,
    setMarkedComments
} from '../../../../actions/actions';
import {connect} from 'react-redux';
import DeleteManyCommentsWithButton from './DeleteManyCommentsWithButton';

interface CommentsModalFooterTagProps {
    hide: () => void;
}

interface CommentsModalFooterStateProps {
    filter: string;
    allComments: OrderedComments;
    filteredComments: OrderedComments;
    markedComments: string[];
}

interface CommentsModalFooterDispatchProps {
    onNewFilter: (newFilter: string) => void;
    setMarkedComments: (markedComments: string[]) => void;
    deleteComments: (commentIds: string[]) => void;
}

type CommentsModalFooterProps = CommentsModalFooterStateProps & CommentsModalFooterDispatchProps & CommentsModalFooterTagProps;

class CommentsModalFooter extends React.Component<CommentsModalFooterProps, {}> {
    constructor(props: CommentsModalFooterProps) {
        super(props);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.markAll = this.markAll.bind(this);
        this.clear = this.clear.bind(this);
        this.deleteMarked = this.deleteMarked.bind(this);
    }

    onFilterChange(e: React.ChangeEvent<HTMLInputElement>) {
        this.props.onNewFilter(e.target.value);
    }

    markAll() {
        const moreThanHalfSelected = this.props.markedComments.length >= Object.keys(this.props.filteredComments).length / 2;
        if (moreThanHalfSelected) {
            this.props.setMarkedComments([]);
        } else {
            const newMarked = Object.values(this.props.filteredComments)
                .map(filteredComment =>
                    [...filteredComment.comments
                        .map(comment => comment.id),
                    ...Object.values(filteredComment.features)
                        .map(feature => feature.comments.map(comment => comment.id))
                        .reduce((prev, curr) => prev.concat(curr), [])
                    ]
                )
                .reduce((prev, curr) => prev.concat(curr), []);
            this.props.setMarkedComments(newMarked);
        }
    }

    deleteMarked() {
        this.props.deleteComments(this.props.markedComments);
        this.props.onNewFilter('');
        this.props.setMarkedComments([]);
    }

    clear() {
        this.props.hide();
        this.props.onNewFilter('');
        this.props.setMarkedComments([]);
    }

    render() {

        const canDelete = Object.keys(this.props.filteredComments).length > 0;
        const moreThanHalfSelected = this.props.markedComments.length >= Object.values(this.props.filteredComments).length / 2;

        let markingButtonText = 'Marker alle';
        if (moreThanHalfSelected && canDelete) {
            markingButtonText = 'Fjern markering';
        } else if (this.props.filter.length > 0) {
            markingButtonText = 'Marker filtrerte';
        }

        return (
            <ModalFooter>
                <div className={'comment-modal-filter-input'}>
                    <label htmlFor={'filterInput'}>Kommentarfilter</label>
                    <input style={{marginRight: '.2em'}}
                           value={this.props.filter}
                           onChange={this.onFilterChange}
                           id={'filterInput'}
                           placeholder={'Objektnavn, brukernavn, fritekst'}/>
                </div>
                <div className={'comment-modal-actions'}>
                    {
                        Object.keys(this.props.allComments).length > 0
                            ? <>
                                <Button disabled={Object.keys(this.props.filteredComments).length === 0} onClick={this.markAll}>{markingButtonText}</Button>
                                <DeleteManyCommentsWithButton commentsToDelete={this.props.markedComments.length} onConfirm={this.deleteMarked}/>
                            </>
                            : null
                    }
                    <Button bsStyle="warning" onClick={this.clear}>Lukk</Button>
                </div>
            </ModalFooter>
        );
    }
}

const mapStateToProps = (state: FeaturesState): CommentsModalFooterStateProps => ({
    allComments: getSelectedComments(state),
    filter: commentsFilter(state),
    filteredComments: getFilteredComments(state),
    markedComments: markedComments(state)
});

const mapDispatchToProps: CommentsModalFooterDispatchProps = {
    onNewFilter: setCommentsFilter,
    setMarkedComments,
    deleteComments: onDeleteComments
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsModalFooter);
